export default function({ store, redirect }) {
  const user = store.state.user
  // console.log('middleware auth | user', user)
  if (!user) redirect('/')
}
